<template>
  <span class="n-pill ar-pill">
    <span class="ar-dot" :class="dotClass" />
    <span class="ar-label">{{ displayLabel }}</span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  status: string
  label?: string
}>()

const statusLabels: Record<string, string> = {
  succeeded: 'Completed',
  running: 'Running',
  queued: 'Queued',
  failed: 'Failed',
  stopped: 'Stopped',
}

const displayLabel = computed(() => props.label || statusLabels[props.status] || props.status)

const dotClass = computed(() => {
  const s = props.status
  if (s === 'running') return 'ar-dot--running'
  if (s === 'succeeded') return 'ar-dot--succeeded'
  if (s === 'failed' || s === 'stopped') return 'ar-dot--failed'
  return 'ar-dot--queued'
})
</script>
